import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../_Modal';
import { Button } from '../_form';
import { FOOD_ORDER_WEBSITE } from '../../../constants/foodOrder';

const CatererContactModal = ({ id, onBack, description, onSuccess }) => (
  <Modal id={ id }>
    <div className='modal__header'>
      Are you sure you want to book this appointment?
    </div>

    {(onBack || onSuccess) && <div className='modal__actions'>
      {onBack && <Button className='form__button form__button--purple rep-apts-index__book-modal__button' onClick={ onBack }>Back</Button>}
      {onSuccess && <Button className='form__button form__button--green rep-apts-index__book-modal__button' onClick={ onSuccess }>Confirm</Button>}
    </div>}
  </Modal>
);

CatererContactModal.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  onBack: PropTypes.func,
  onSuccess: PropTypes.func
};

export default CatererContactModal;



// WEBPACK FOOTER //
// ./app/components/shared/modal/CatererContactModal.jsx